const QuizComplete = ({ questionBank, category, player, level, score, onReset, onNewGame }) => {
  const successMessageDiv = <p className="title has-text-centered has-text-success">Congratulations!</p>;
  const failureMessageDiv = <p className="title has-text-centered has-text-danger">You lost!</p>;

  return (
    <>
      <div>
        <p className="subtitle has-text-centered">
          {category.name} ({level})
        </p>
      </div>
      <div>
        {score > 5 ? successMessageDiv : failureMessageDiv}
        <p className="title is-size-4 has-text-centered">{player}, your score is</p>
        <p className="title has-text-centered">
          {score} out of {questionBank.length}
        </p>
      </div>
      <div>
        <button type="button" className="button p-6 is-large is-fullwidth has-background-primary-dark title" onClick={onReset}>
          Again!
        </button>
        <button type="button" className="button p-6 is-large is-fullwidth play-button  has-text-primary-light title" onClick={onNewGame}>
          New Game
        </button>
      </div>
    </>
  );
};

export default QuizComplete;
